import { render } from "./BrandDriverValuesForm.vue?vue&type=template&id=6fa7a1a9"
import script from "./BrandDriverValuesForm.vue?vue&type=script&lang=js"
export * from "./BrandDriverValuesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__